import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AccountUserService } from 'src/app/services/account-user.service';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { ItemViewComponent } from './item-view/item-view.component';

@Component({
    selector: 'app-bookingview',
    templateUrl: './bookingview.component.html',
    styleUrls: ['./bookingview.component.css']
})
export class BookingViewComponent implements OnInit {
    bookingConfig: any = {};
    bookingTypes: any = [];
    tableFilters: any = '';
    api_error: any;
    api_success: any;
    bookingViewfilterParam = '';
    bookingData: any = [];
    filtervalue: any = [];
    salesChannel: any;
    bookingViewDetails: any;
    btndisabled = true;
    id: string;
    bookingBy = 'CONFIRMATION_ID' 
    confirmPlaceholder;
    showPayment;
    bookingNumber;
    orderItem: any = [];
    constructor(private commonfilterService: CommonfilterService, private dialog: MatDialog,private commonService: CommonfilterService, private accountuserService: AccountUserService) {
        this.commonfilterService.getConfigData()
        .subscribe(res => {
            this.bookingConfig = res;
            this.bookingTypes = this.bookingConfig.kindOfBooking;
        });
    }

    ngOnInit() {
        this.bookingNumber = true;
        this.confirmPlaceholder = 'c-62598p8-1'; 
    }
    onChange(event) {
        if (event.target.value === 'PAYMENT_ID') {
            this.confirmPlaceholder = 'pay_FzV6vqcrEjn1O0';
            this.showPayment = true;
            this.bookingNumber = false;
        }
        else {
            this.bookingNumber = true;
            this.showPayment = false;
            this.confirmPlaceholder = 'c-62598p8-1';  
        }
      }
    resetApiErrors() {
        this.btndisabled = false;
        if(this.id === ''){
            this.btndisabled = true;
        }
        this.api_error = null;
        this.api_success = null;
      }
    getBookingView() {
      
        this.tableFilters = this.commonService.filterParams_without_operators('bookingView');
        this.bookingViewfilterParam = this.tableFilters
        this.api_error = '';
        this.api_success = '';
        this.accountuserService.getBookingView(this.bookingViewfilterParam)
            .subscribe(data => {
                this.bookingData = data;
                this.bookingData.forEach(booking_details => {
                    this.bookingViewDetails = booking_details;
                    this.orderItem = this.bookingViewDetails.orderDetails.orderItem;

                })
                // this.bookingViewDetails = this.bookingData[0];
                // console.log(this.bookingViewDetails);
                // this.bookingData.forEach((arrObj) => {
                //     var jsonData = JSON.parse(arrObj.valueInput);
                //     jsonData.data.forEach(({name}) => console.log(name));
                //   });
            },
                (error) => {
                    this.api_error = error.error;
                });
    }
    getview(){
    const dialogRef = this.dialog.open(ItemViewComponent, {
        width: '600px',
        height: '250px',
        data: this.orderItem 
      });
    
      dialogRef.afterClosed().subscribe(result => {
        
      });
      }
}